/**
 * PageTitleService – manages the dynamic page title for the SnapHub PWA.
 *
 * Simple singleton service that stores the current page title.
 * The router sets the title on each navigation; the header component reads it.
 *
 * Validates: Requirements 37.1, 37.2
 */

// ---------------------------------------------------------------------------
// State
// ---------------------------------------------------------------------------

let currentTitle = '';

// ---------------------------------------------------------------------------
// Public API
// ---------------------------------------------------------------------------

/**
 * Set the current page title.
 */
export function setTitle(title: string): void {
  currentTitle = title;
}

/**
 * Get the current page title.
 */
export function getTitle(): string {
  return currentTitle;
}
